(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data('inputPhone');
				var prefix = '+7';
				var rawlen = 10;
				var tr = {};
				tr[0] = ' (';
				tr[3] = ') ';
				tr[6] = ' ';
				tr[8] = ' ';

				$this.checkPhone = function (event) {
					var val = $this.val();
					val.replace(/[^0-9]/g, '');

					if (val[0] === '8') {
						val = '+7' + val.substring(1);
						$this.val(val);
					}

					if (val[0] === '7') {
						val = '+7' + val.substring(1);
						$this.val(val);
					}

					if (val.length === '18') {
						val = val.substring(0, 17);
						$this.val(val);
					}

					if (val[2] === "+") {
						val = val.substring(3);
						$this.val(val);
					}

					if ((val[2] === '8' && val[3] === "9") || (val[2] === '7' && val[3] === '9')) {
						val = val.substring(3);
						$this.val(val);
					}
					var raw = val.replace(RegExp('^' + prefix.replace('+', '\\+')), '').replace(/\D/g, '').substring(-rawlen, rawlen);
					var ret = '';
					for (var i = 0; i < raw.length; i++) {
						ret = ret + (tr[i] ? tr[i] : '') + raw[i];
					}
					val = prefix + ret;
					$this.val(val);

					if (event && event.type === "focusout" && $this.val() === prefix) {
						$this.val('');
					}

					var phoneLength = val.replace(/[^0-9]/g, '').length;
					var isRequired = $this.prop("required");
					var isValid = (phoneLength === 11 || (($this.val() === prefix || $this.val() === "") && !isRequired));
					$this.toggleClass("invalid", !isValid);
					return val;
				};

				if (!data) {
					if ($this.val().length > 0) {
						$this.checkPhone();
					}
					$this.data('inputPhone', {
						target: $this
					});
					$this.on('input.inputPhone', function (event) {
						event = event.originalEvent || event;
						var target = event.target;
//						var cursor = target.selectionStart;

						target.classList.toggle("invalid", false);

						target.value = $this.checkPhone();
//						target.selectionStart = cursor;
//						target.selectionEnd = cursor;

						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					});
					$this.on("focusout.inputPhone change.inputPhone", $this.checkPhone);
				}

			});

		},
		destroy: function () {
			return this.each(function () {
				var $this = $(this);
				$this.removeData('inputPhone');
				$(window).unbind('.inputPhone');
			});

		}
	};
	$.fn.inputPhone = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.inputPhone');
		}
	};
})(jQuery);


